// extracted by mini-css-extract-plugin
module.exports = {"MotorDataPhaseItems":"MotorDataPhaseltems__MotorDataPhaseItems___2L1MN"};